var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.1875V6.125M11 12.25H11.0092M9.075 16.8L10.4133 18.5033C10.6124 18.7566 10.7119 18.8833 10.8339 18.9286C10.9407 18.9682 11.0593 18.9682 11.1661 18.9286C11.2881 18.8833 11.3876 18.7566 11.5867 18.5033L12.925 16.8C13.1937 16.458 13.3281 16.287 13.492 16.1564C13.7105 15.9824 13.9685 15.8592 14.2455 15.7968C14.4532 15.75 14.6771 15.75 15.125 15.75C16.4063 15.75 17.047 15.75 17.5524 15.5502C18.2262 15.2838 18.7616 14.7727 19.0407 14.1295C19.25 13.6471 19.25 13.0356 19.25 11.8125V6.825C19.25 5.35486 19.25 4.61979 18.9503 4.05827C18.6866 3.56435 18.2659 3.16278 17.7485 2.91111C17.1602 2.625 16.3901 2.625 14.85 2.625H7.15C5.60986 2.625 4.83978 2.625 4.25153 2.91111C3.73408 3.16278 3.31338 3.56435 3.04973 4.05827C2.75 4.61979 2.75 5.35486 2.75 6.825V11.8125C2.75 13.0356 2.75 13.6471 2.95933 14.1295C3.23844 14.7727 3.77379 15.2838 4.44762 15.5502C4.95299 15.75 5.59366 15.75 6.875 15.75C7.32286 15.75 7.5468 15.75 7.75455 15.7968C8.03155 15.8592 8.28952 15.9824 8.50804 16.1564C8.67192 16.287 8.80628 16.458 9.075 16.8Z",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.d320ea8334408189851e70a7c8b97ee1.svg";
export { ForwardRef as ReactComponent };